class SiteFooter extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: -apple-system, "SF Pro Text", "SF Pro Display",
                       BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif;
        }

        footer {
          height: auto;
          min-height: 60vh;
          position: relative;
          background-color: #b78883;
          overflow: hidden;
        }

        .footer-bg {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          object-fit: contain;
          opacity: 0.9;
          pointer-events: none;
          user-select: none;
        }

        .footer-content {
          position: relative;
          max-width: 80rem;
          margin: 0 auto;
          padding: 2.5rem 1rem 140px; /* Leave bottom padding on mobile to clear the logo */
          z-index: 10;
        }

        .footer-inner {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          color: #000;
          font-size: 16px;
        }

        .footer-cta-col {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          max-width: 280px;
          text-align: left;
        }

        .footer-cta-title {
          font-size: 16px;
          font-weight: 700;
          color: #000000;
          text-transform: uppercase;
        }

        .footer-cta-text {
          font-size: 14px;
          color: #222222;
          line-height: 1.4;
          opacity: 0.95;
        }

        .footer-cta-btn {
          display: inline-block;
          align-self: flex-start;
          background-color: #000000;
          color: #ffffff;
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          padding: 8px 18px;
          border-radius: 6px;
          text-decoration: none;
          transition: background-color 0.2s, transform 0.1s;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
          margin-top: 4px;
        }

        .footer-cta-btn:hover {
          background-color: #222222;
          transform: translateY(-1px);
        }

        .footer-copyright {
          text-align: left;
        }

        .footer-address {
          text-align: left;
        }

        .footer-contact {
          text-align: left;
        }

        .footer-contact p {
          margin: 0;
        }

        .font-semibold {
          font-weight: 600;
        }

        @media (min-width: 768px) {
          footer {
            height: 60vh;
          }

          .footer-content {
            padding: 2.5rem 2.5rem;
          }

          .footer-inner {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
          }
        }
      </style>

      <footer>
        <img 
          src="${new URL('./images/footer.png', import.meta.url).href}" 
          alt="FUE Global"
          loading="lazy" decoding="async"
          class="footer-bg"
        />

        <div class="footer-content">
          <div class="footer-inner">
            <div class="footer-cta-col">
              <span class="font-semibold footer-cta-title">Become a Member</span>
              <p class="footer-cta-text">Advance your career in hair restoration alongside global FUE experts.</p>
              <a href="https://member.fueasia.org/" target="_blank" rel="noopener noreferrer" class="footer-cta-btn">Join FUE Global</a>
            </div>

            <div class="footer-copyright">
              © 2026 FUE Global.<br/>All rights reserved.
            </div>

            <div class="footer-address">
              <span class="font-semibold">Address:</span>
              E-13, Basement Defense Colony,<br/> Ring Rd, New Delhi 110024
            </div>

            <div class="footer-contact">
              <p>
                <span class="font-semibold">Phone:</span> +91 89878 74547
              </p>
              <p>
                <span class="font-semibold">E-mail:</span> scientific@fueasia.org, contact@fueasia.org
              </p>
            </div>
          </div>
        </div>
      </footer>
    `;
  }
}

customElements.define('site-footer', SiteFooter);
